// import HeaderHome from "./HeaderHome";
// import Newest from "./Newest";
import { useChangeRoute } from "@/hooks/useChangeRoute";
import { skipNullParams } from "@/utils";
import ClickOutside from "@/vendor/click-outside";
import {
  lockScroll,
  unlockScroll,
} from "@/vendor/scroll-locker/useScrollLocker";
import clsx from "clsx";
import { useRouter } from "next/router";
import { useEffect, useRef, useState } from "react";
const suggestItem = [
  "Vị trí",
  "Chủ đầu tư",
  "Giá bán",
  "Khuôn viên",
  "Giấy tờ pháp lý",
  "Bãi đậu xe",
];
const InputSearchReview = ({ className }: { className?: string }) => {
  const router = useRouter();
  const [val, setVal] = useState("");
  const [open, setOpen] = useState(null);
  const [focus, setFocus] = useState(false);
  const inputRef = useRef<HTMLInputElement>(null);
  const { loading } = useChangeRoute();

  useEffect(() => {
    setVal((router.query.comment as string) || "");
    setOpen(false);
  }, [router.query]);

  useEffect(() => {
    if (focus) lockScroll();
    else unlockScroll();
    return () => {
      unlockScroll();
    };
  }, [focus]);
  return (
    <ClickOutside
      active={open}
      onClick={() => {
        setOpen(false);
      }}>
      <div className="relative md:w-fit">
        <div className="flex items-center md:w-[21.5rem] rounded-full border px-3 py-1 bg-white text-grey-600 relative duration-300">
          <i className="mrv mrv-search text-fs-20 mr-1"></i>
          <input
            placeholder="Tìm nội dung review bạn quan tâm..."
            value={val}
            ref={inputRef}
            onFocus={() => {
              setFocus(true);
              setOpen(true);
            }}
            onBlur={() => setFocus(false)}
            className="h-[28px] mr-5 w-full text-base"
            onChange={(e) => setVal(e.target.value.slice(0, 100))}
            onKeyUp={(e) => {
              if (
                e.key === "Enter" &&
                !loading &&
                ((!(e.target as HTMLInputElement).value &&
                  router.query.comment) ||
                  (e.target as HTMLInputElement).value)
              )
                router.push({
                  query: skipNullParams({
                    ...router.query,
                    comment: (e.target as HTMLInputElement).value
                      ?.trim()
                      .replace(/\s\s+/g, " "),
                  }),
                });
            }}
          />
        </div>

        {val ? (
          <div
            className="absolute top-1 right-3 cursor-pointer "
            onClick={() => {
              if (!loading)
                if (!focus)
                  router.push({
                    query: skipNullParams({
                      ...router.query,
                      comment: null,
                    }),
                  });
                else {
                  setVal("");
                  inputRef?.current.focus();
                }
            }}>
            <i className="mrv mrv-cancel text-fs-20"></i>
          </div>
        ) : null}
        {open ? (
          <div className="w-[336px] mt-2 absolute bg-white z-[2500] p-4 shadow-lg">
            <div className="font-semibold text-grey-800 mb-3">
              Chủ đề được quan tâm
            </div>
            <div className="flex flex-wrap gap-2">
              {suggestItem.map((item) => {
                const isActive = val
                  .toLocaleLowerCase()
                  .includes(item.toLocaleLowerCase());
                return (
                  <div
                    className={clsx(
                      "border border-grey-200 px-3 py-1 bg-grey-50 text-fs-12 rounded-full font-medium cursor-pointer select-none",
                      isActive ? "!border-blue-500" : "border-grey-200"
                    )}
                    onClick={() => {
                      // router.push({
                      //   query: skipNullParams({
                      //     ...router.query,
                      //     comment: item,
                      //   }),
                      // });
                      if (!isActive) setVal((val + item + " ").slice(0, 100));
                      inputRef.current.focus();
                    }}
                    key={item}>
                    {item}
                  </div>
                );
              })}
            </div>
          </div>
        ) : null}
      </div>
    </ClickOutside>
  );
};

export default InputSearchReview;
